"use strict";
/*
 * Created on 01 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ProductVATByProduct_1 = require("../model/ProductVATByProduct");

var ProductVATByProductConverter_1 = require("./ProductVATByProductConverter");

var ProductVATByProductDataConverter_1 = require("./ProductVATByProductDataConverter");
/**
 * Implementation of {@link ProductVATByProductConverter}
 *
 * @author JMe
 */


var ProductVATByProductConverterImpl =
/*#__PURE__*/
function (_ProductVATByProductC) {
  _inherits(ProductVATByProductConverterImpl, _ProductVATByProductC);

  /**
   * @param dataPerEntityConverter
   */
  function ProductVATByProductConverterImpl(dataPerEntityConverter) {
    var _this;

    _classCallCheck(this, ProductVATByProductConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductVATByProductConverterImpl).call(this));
    _this.dataPerEntityConverter = dataPerEntityConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ProductVATByProductConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        dataPerProduct: conversions.asObjectArray(source, 'dataPerProduct', function (obj) {
          return _this2.dataPerEntityConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this3 = this;

      return new ProductVATByProduct_1.ProductVATByProduct(ProductVATByProduct_1.ProductVATByProduct.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), conversions.asObjectList(source, 'dataPerProduct', function (doc) {
        return _this3.dataPerEntityConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return ProductVATByProductConverterImpl;
}(ProductVATByProductConverter_1.ProductVATByProductConverter);

ProductVATByProductConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ProductVATByProductDataConverter_1.ProductVATByProductDataConverter])], ProductVATByProductConverterImpl);
exports.ProductVATByProductConverterImpl = ProductVATByProductConverterImpl;